/**
 * Asynchronously loads the component for Checkout
 */
import Loadable from 'react-loadable';
import LoadingIndicator from 'components/LoadingIndicator';

export default Loadable({
    loader: () => import('./index'),
    loading: LoadingIndicator,
});



// WEBPACK FOOTER //
// ./app/containers/Checkout/ThankYouPage/Loadable.js